module.exports = __webpack_public_path__ + "static/img/4areaB_3.94e5d03.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_3.png
// module id = 1192
// module chunks = 1